import Backbone from "backbone";
import Validation from "backbone-validation";
import _extend from "lodash/extend";

const Model = Backbone.Model.extend({
    _validate(attrs, options) {
        if (!options.validate || !this.validate) return true;
        if (options.validate != "partial") attrs = _extend({}, this.attributes, attrs);
        const error = this.validate(attrs, options) || null;
        this.validationError = error;
        if (!error) return true;
        this.trigger("invalid", this, error, _extend(options, { validationError: error }));
        return false;
    },
});

_extend(Validation.validators, {
    // eslint-disable-next-line consistent-return
    notags: (value) => {
        if (value && value.match(/<\/?.+>/)) {
            return "Please enter a valid value";
        }
    },

    // eslint-disable-next-line consistent-return
    noscript: (value) => {
        if (value && value.match(/<\/?\s*script\s*>/gi)) {
            return "Please enter a valid value";
        }
    },
});

export default {
    Model,
};
